import type { CommunityTestimonial } from "@upsquad/shared";
import { getInitials } from "@upsquad/shared";
import { useEffect, useState } from "react";
import { Avatar } from "./ui";

interface TestimonialsCarouselProps {
	testimonials: CommunityTestimonial[];
}

export function TestimonialsCarousel({ testimonials }: TestimonialsCarouselProps) {
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		if (testimonials.length <= 1) return;
		const interval = setInterval(() => {
			setActiveIndex((prev) => (prev + 1) % testimonials.length);
		}, 6000);
		return () => clearInterval(interval);
	}, [testimonials.length]);

	const active = testimonials[activeIndex] ?? testimonials[0];
	if (!active) return null;

	return (
		<div className="flex flex-col justify-end h-full text-white">
			{testimonials.length > 1 && (
				<div className="flex gap-1.5 mb-6">
					{testimonials.map((_, i) => (
						<button
							type="button"
							key={i}
							onClick={() => setActiveIndex(i)}
							className={`w-2.5 h-2.5 rounded-full transition-colors ${i === activeIndex ? "bg-white" : "bg-white/40"}`}
							aria-label={`Testimonial ${i + 1}`}
						/>
					))}
				</div>
			)}
			<div className="min-h-[160px]">
				<blockquote className="text-xl font-semibold leading-tight mb-6">{active.quote}</blockquote>
				<div className="flex items-center gap-3">
					<Avatar size="sm">
						{active.author_avatar_url ? <Avatar.Image src={active.author_avatar_url} alt={active.author_name} /> : null}
						<Avatar.Fallback>{getInitials(active.author_name)}</Avatar.Fallback>
					</Avatar>
					<div>
						<p className="font-medium text-sm">{active.author_name}</p>
						{active.author_role && <p className="text-sm text-white/70">{active.author_role}</p>}
					</div>
				</div>
			</div>
		</div>
	);
}
